module.exports = __webpack_public_path__ + "img/39.99e570f7.png";